module.exports = __webpack_public_path__ + "img/logo_oficial.3ca55aad.png";